var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEventRsvpContent = function SvgEventRsvpContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FF855F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.713 14.639c-.738 0-1.336.604-1.336 1.35v13.22c0 .895.718 1.62 1.603 1.62h16.031c.886 0 1.604-.725 1.604-1.62V15.99c0-.746-.599-1.35-1.336-1.35H11.713Zm5.077 4.857c0-.298.239-.54.534-.54h1.603c.295 0 .534.242.534.54v1.619c0 .298-.239.54-.534.54h-1.603a.537.537 0 0 1-.535-.54v-1.62Zm-3.741 3.777c0-.298.24-.54.534-.54h1.603c.296 0 .535.242.535.54v1.62c0 .297-.24.539-.535.539h-1.603a.537.537 0 0 1-.534-.54v-1.619Zm0 3.778c0-.298.24-.54.534-.54h1.603c.296 0 .535.242.535.54v1.619c0 .298-.24.54-.535.54h-1.603a.537.537 0 0 1-.534-.54V27.05Zm4.275-4.317a.537.537 0 0 0-.535.54v1.618c0 .298.24.54.535.54h1.603a.537.537 0 0 0 .534-.54v-1.619c0-.298-.239-.54-.534-.54h-1.603Zm0 3.777a.537.537 0 0 0-.535.54v1.619c0 .298.24.54.535.54h1.603a.537.537 0 0 0 .534-.54V27.05c0-.298-.239-.54-.534-.54h-1.603Zm3.206-3.238c0-.298.24-.54.534-.54h1.604c.295 0 .534.242.534.54v1.62c0 .297-.24.539-.534.539h-1.604a.537.537 0 0 1-.534-.54v-1.619Zm.534 3.238a.537.537 0 0 0-.534.54v1.619c0 .298.24.54.534.54h1.604a.537.537 0 0 0 .534-.54V27.05c0-.298-.24-.54-.534-.54h-1.604Zm-.534-7.015c0-.298.24-.54.534-.54h1.604c.295 0 .534.242.534.54v1.619c0 .298-.24.54-.534.54h-1.604a.537.537 0 0 1-.534-.54v-1.62Zm4.275 3.238a.537.537 0 0 0-.534.54v1.618c0 .298.239.54.534.54h1.603a.537.537 0 0 0 .535-.54v-1.619c0-.298-.24-.54-.535-.54h-1.603Zm-.534-3.238c0-.298.239-.54.534-.54h1.603c.295 0 .535.242.535.54v1.619c0 .298-.24.54-.535.54h-1.603a.537.537 0 0 1-.534-.54v-1.62Z",
    fill: "#fff",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.652 10.862c0-.596.478-1.08 1.069-1.08.59 0 1.069.484 1.069 1.08v1.619h6.412v-1.62c0-.595.478-1.079 1.069-1.079.59 0 1.069.484 1.069 1.08v1.619h2.671c.886 0 1.604.725 1.604 1.619v1.888c0 .745-.599 1.35-1.336 1.35H11.713a1.343 1.343 0 0 1-1.336-1.35V14.1c0-.894.718-1.62 1.603-1.62h2.672v-1.618Z",
    fill: "url(#event-rsvp-content_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "event-rsvp-content_svg__a",
    x1: 19.996,
    y1: 9.782,
    x2: 19.996,
    y2: 17.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.25
  })))));
};

export default SvgEventRsvpContent;